import type { CSS } from '@grupoboticario/flora-react'

import { textStyles } from '@/pages/benefits/events/styles'

export const getTextCss = (textColor: string): CSS => ({
  ...textStyles,
  color: textColor
})
